

type ErrorKey = {
  [key: string]: string
}

const ErrorsKeys: ErrorKey = {
  USER_NOT_FOUND: 'httpErrors.userNotFound',
  SERVER_ERROR: 'httpErrors.serverError',
  CHALLENGE_COULD_NOT_BE_CREATED: 'httpErrors.challengeCouldNotBeCreated',
  CHALLENGE_COULD_NOT_BE_UPDATED: 'httpErrors.challengeCouldNotBeUpdated',
  CHALLENGE_NOT_FOUND: 'httpErrors.challengeNotFound',
  REQUEST_PARAMETER_INVALID: 'httpErrors.requestParameterInvalid',
  CHALLENGE_STATUS_PENDING: 'httpErrors.challengeStatusPending',
  CHALLENGE_HAS_BEEN_USED: 'httpErrors.challengeHasBeenUsed',
  CHALLENGE_NOT_AVAILABLE: 'httpErrors.challengeNotAvailable',
  SESSION_REQUIRED: 'commons.errors.sessionRequired',
  INVALID_TOKEN: 'commons.errors.invalidToken',
  CHALLENGE_IN_PROGRESS: 'httpErrors.challengeInProgress'
};

/**
 * ## Get Translation Error Index By Key Function
 * Match the given error key from backend and get the related region error for translation;
 *
 * @param {String} key the backend key on error case
 * @return {String} `response` the equivalent region key for translation
 *
 * @description in case of unmatching error key, the function will return a generic error key,
 * in order to show always something and prevent fatal errors and critical shutdown execution for the code;
 */
export function getTranslationErrorIndexByKey(key: string): string {
  let response = ErrorsKeys[key];
  if (!response) {
    response = 'httpErrors.defaultError';
  }
  return response;
}


export function getErrorMessage(error: any): string {
  if (error instanceof Error) {
    return error.message;
  }

  const message = error.message;
  return (message) ? message : '';
}
